// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  background-color: #EFEFEF;
}

.alinhamento {
  margin-top: 50px !important;
}

.bg-verde {
  background-color: #50B848;
  color: #ffffff;
}

.img-logo {
  width: 82px;
  height: auto;
}

.txt-cadastro {
  text-align: center;
}

.txt-parabens {
  text-align: center;
  margin: 30px 0;
}`, "",{"version":3,"sources":["webpack://./src/app/routes/pages/recuperar-senha/recuperar-senha.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AACA;EACE,2BAAA;AAEF;;AACA;EACE,yBAAA;EACA,cAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;AAEF;;AACA;EACE,kBAAA;AAEF;;AACA;EACE,kBAAA;EACA,cAAA;AAEF","sourcesContent":[".wrapper {\n  background-color: #EFEFEF;\n}\n.alinhamento {\n  margin-top: 50px !important;\n}\n\n.bg-verde {\n  background-color: #50B848;\n  color: #ffffff;\n}\n\n.img-logo {\n  width: 82px;\n  height: auto;\n}\n\n.txt-cadastro {\n  text-align: center;\n}\n\n.txt-parabens {\n  text-align: center;\n  margin: 30px 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
